import utils from '../common/components/utils';
import websocketClient from '../websocket/client';

// Chat Assistant
var CodejigChat = Backbone.View.extend({
    
    $chatEl: null,

    md: window.markdownit && window.markdownit(),

    isOpened: false,
    messagesLoaded: false,

    savedFileData: {},

    lastRole: null,
    lastMsgId: null,


    initialize: function () {
        this.$chatEl = $("#codejig-chat");

        this.$chattoggleBtn = $("#chat-button");
        this.$chattoggleBtn.show();
        this.$chattoggleBtn.on("click", (e) => {
            if(this.isOpened) {
                this.removeChat();
            } else {
                this.addChat();
            }
        });

        // new rules for markdownit
        this.md && this.md.use(function(md) {
            md.inline.ruler.before('text', 'icon-file', function(state, silent) {
                const start = state.pos;
                const marker = '[icon-file:';
                
                if (state.src.slice(start, start + marker.length) !== marker) {
                  return false;
                }
                const end = state.src.indexOf(']', start);
                if (end === -1) {
                  return false;
                }            
                if (!silent) {
                  const token = state.push('icon_file', '', 0);
                  token.content = state.src.slice(start + marker.length, end);
                }
                state.pos = end + 1;
                return true;
              });
            
              md.renderer.rules.icon_file = function(tokens, idx) {
                const content = tokens[idx].content;
                return `<br><span class="glyphicon glyphicon-file" style="color: #ccc;height: 30px;font-size: 24px;float: left;"></span><span style="float: inherit;color: #d7d7d7;">${content}</span>`;
              };
          });
    },

    removeChat: function () {
        document.getElementsByTagName("body").item(0).classList.remove('codejig-chat-opened');

        this.$chatEl.html("");
        this.isOpened = false;
        this.messagesLoaded = false;

        this.destroyListeners();
    },
      
    addChat: async function () {
        document.getElementsByTagName("body").item(0).classList.add('codejig-chat-opened');

        this.$chatEl.html("");

        this.$chatEl.append(
            `<div class="aichat">
              <span class="chatClose"><i class="material-icons notranslate" style="font-size: 23px;">close</i></span>
              <div class="messagesContent scrollable ps-container ps-theme-default ps-active-y"></div>
              <div class="dropArea" style="display: none;">Drag & Drop files here</div>
              <div class="chatInput">
                <div class="tryAgain" style="display: none;">Try again</div>
                <span class="waiter" style="display: none;">AI is writing ...</span>
                <span id="refresh-button" type="button">
                    <svg fill="#bec4cd" height="64px" width="64px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 315.001 315.001" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 315.001 315.001" stroke="#bec4cd"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="m312.951,2.05c-2.733-2.731-7.165-2.732-9.9,0l-132.826,132.824c-2.661-1.336-5.511-2.049-8.468-2.049-7.14,0-13.186,3.962-16.813,7.048-3.48-0.997-7.107-1.501-10.828-1.501-19.045,0-38.755,13.193-58.068,27.796-0.002,0.001-0.003,0.002-0.005,0.004-3.023,2.285-6.036,4.604-9.035,6.913l-.975,.751c-31.116,23.949-62.928,47.934-63.247,48.174-1.618,1.22-2.628,3.081-2.769,5.102-0.141,2.021 0.601,4.005 2.033,5.438l80.4,80.4c1.317,1.316 3.101,2.05 4.95,2.05 0.162,0 0.325-0.006 0.488-0.017 2.021-0.142 3.882-1.152 5.102-2.771 0.239-0.317 24.222-32.129 48.175-63.248l.76-.986c19.943-25.901 40.528-52.636 33.207-77.93 2.977-3.502 6.767-9.254 7.027-16.062 0.124-3.229-0.584-6.333-2.032-9.215l132.824-132.821c2.733-2.734 2.733-7.166 0-9.9zm-170.333,221.813l-51.471-51.475c4.971-3.616 9.916-7.013 14.771-9.942l46.671,46.673c-2.917,4.807-6.312,9.731-9.971,14.744zm-12.546,16.563c-17.571,22.827-35.156,46.024-43.408,56.937l-9.466-9.466 23.992-27.241c2.556-2.901 2.274-7.325-0.626-9.88-2.902-2.556-7.326-2.274-9.88,0.626l-23.405,26.576-10.18-10.18 8.904-8.903c2.734-2.733 2.734-7.166 0.001-9.899-2.733-2.733-7.166-2.733-9.899-0.001l-8.905,8.904-10.178-10.178 26.573-23.406c2.901-2.556 3.182-6.979 0.626-9.88-2.556-2.902-6.979-3.182-9.88-0.626l-27.239,23.992-9.465-9.465c10.912-8.252 34.108-25.838 56.936-43.407l.976-.752c1.427-1.099 2.857-2.2 4.29-3.298l54.28,54.283c-1.089,1.42-2.186,2.845-3.286,4.274l-.761,.99zm32.46-77.439c-2.321,1.99-3.083,5.257-1.88,8.068 3.259,7.619 2.262,16.02-1.348,24.979l-40.293-40.295c5.258-2.125 10.325-3.368 15.104-3.368 3.505,0 6.721,0.646 9.83,1.977 2.814,1.202 6.079,0.441 8.068-1.881 1.515-1.768 6.071-5.643 9.743-5.643 0.938,0 2.403,0.22 4.301,2.117 1.963,1.962 2.145,3.496 2.113,4.479-0.129,3.896-4.236,8.341-5.638,9.567z"></path> </g></svg>
                </span>
                <span class="loadImage"><span class="glyphicon glyphicon-paperclip"></span></span>
                <span class="hideImage" style="display: none;"><span class="glyphicon glyphicon-remove"></span></span>
                <img class="displayImage" src="">
                <span class="fileData" style="display: none;"><span class="glyphicon glyphicon-file" style="height: 100%;align-content: center;"></span></span>
                <input type="file" class="imageInput" 
                        accept="image/*, text/x-c, text/x-c++, text/x-csharp, text/css, 
                        application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, 
                        text/x-golang, text/html, text/x-java, text/javascript, 
                        application/json, text/markdown, application/pdf, text/x-php, 
                        application/vnd.openxmlformats-officedocument.presentationml.presentation, 
                        text/x-python, text/x-script.python, text/x-ruby, application/x-sh, 
                        text/x-tex, application/typescript, text/plain" 
                    style="display:none;">
                <span class="downbtn" style="display: none;"><span class="glyphicon glyphicon-arrow-down"></span></span>
                <textarea placeholder="Type some text here..."></textarea>
                <div class="styleDiv"><div></div></div>
                <a id="send-button" type="button">
                  <span class="glyphicon glyphicon-send" ></span>
                </a>
              </div>
            </div>`
        );
        this.$aichat = this.$chatEl.find(`.aichat`);
        this.$chatInput = this.$chatEl.find(`.chatInput textarea`);
        this.$chatSendBtn = this.$chatEl.find(`.chatInput #send-button`);
        this.$chatCloseBtn = this.$chatEl.find(`.chatClose`);
        this.$clearChatBtn = this.$chatEl.find(`.chatInput #refresh-button`);
        this.$messagesContent = this.$chatEl.find(`.messagesContent`);
        this.$waiter = this.$chatEl.find(`.waiter`);
        this.$loadImage = this.$chatEl.find(`.loadImage`);
        this.$hideImage = this.$chatEl.find(`.hideImage`);
        this.$displayImage = this.$chatEl.find(`.displayImage`);
        this.$fileData = this.$chatEl.find(`.fileData`);
        this.$image = this.$chatEl.find(`.imageInput`);
        this.$dropArea = this.$chatEl.find(`.dropArea`);
        this.$tryAgain = this.$chatEl.find(`.tryAgain`);
        this.$downbtn = this.$chatEl.find(`.downbtn`);

        this.$chatInput.on("input", function () {this.style.height = 0;this.style.height = (this.scrollHeight) + "px";});
    
        this.$chatSendBtn.on("click", (e) => {this.sendMessage()});
        this.$chatCloseBtn.on("click", (e) => {this.removeChat()});
        this.$chatInput.on("keypress", (e) => { if (e.which == 13 && !e.shiftKey) {e.preventDefault();this.sendMessage()}});

        this.$messagesContent.on( 'scroll', (e) => {
            if (this.$messagesContent[0].scrollTop + this.$messagesContent[0].clientHeight + 10 < this.$messagesContent[0].scrollHeight) {
                this.$downbtn.show();
            } else {
                this.$downbtn.hide();
            }
         });
        this.$downbtn.on("click", (e) => {this.scrollBottom(); this.$downbtn.hide();});

        this.$loadImage.on("click", (e) => {
            this.$image.click();
        });
        this.$hideImage.on("click", (e) => {
            this.savedFileData = {};        
            this.$displayImage.attr('src', "");    
            this.$fileData.hide();
            this.$loadImage.show();
            this.$hideImage.hide();
        });

        this.$clearChatBtn.on("click", (e) => {
            this.clearChatContext()
        })

        this.$chatInput.on("paste", (e) => {
            const items = e.originalEvent.clipboardData.items;
            for (let i = 0; i < items.length; i++) {
                this.loadFileOrImage(items[i].getAsFile());
            }
        });
        this.$image.change((e) => {this.loadFileOrImage(e.target.files[0])});

        this.$aichat.on('dragenter dragover dragleave drop', (e) => {e.preventDefault(); e.stopPropagation();});
        this.$aichat.on('dragenter dragover', () => {this.$dropArea.show();});
        this.$aichat.on('dragleave drop', () => {this.$dropArea.hide();});
        this.$aichat.on('drop', (e) => {this.loadFileOrImage(e.originalEvent.dataTransfer.files[0])});

        this.$tryAgain.on("click", (e) => {
            this.$tryAgain.hide();
            this.$waiter.show();
            this.tryAgain();
        });

        this.isOpened = true;

        this.$waiter.show();

        await this.createChatAndLoadContext();
    },

    sendMessage: function () {
        if (this.$chatInput.val()) {
          let message = this.$chatInput.val();      
          this.$chatInput.val("");
          this.$chatInput.height("40px");
          this.$waiter.show();
    
          this._sendMessage(message);

          this.savedFileData = {};        
          this.$displayImage.attr('src', "");
          this.$fileData.hide();    
          this.$loadImage.show();
          this.$hideImage.hide();
        }
    },

    _fillMsg: function (con, msg) {
        if (con.type == "text"){
            this.lastText[msg.index] = (this.lastText[msg.index] || "") + con.text.value;
            if(msg.attachments && msg.attachments.length) {
                let att = " [icon-file:";
                if(msg.metadata && msg.metadata.fileName) {
                    att = att + msg.metadata.fileName + "]";
                } else {
                    att = att + "file]";
                }
                this.lastText[msg.index] = (this.lastText[msg.index] || "") + att;
            }
        } else if(con.type == "image_file") {
            if(con.image_file) {
                this.lastText[msg.index] = (this.lastText[msg.index] || "") + " ![user image](" + con.image_file + ")";
            }
        }
    },

    fillMsg: async function (msg) {
        if(this.messagesLoaded && msg.type == "contextLoading") return;
        if(msg.type == "endcontextLoadingFirstRun") {
            this.messagesLoaded = true;
            return;
        }

        if(msg.role == "assistant") {
            this.$waiter.hide();
        }

        if (this.lastRole == msg.role && this.lastMsgId == msg.id && this.$messagesContent.find(".chatMessage:last").hasClass(msg.role)) {
            for(let con of msg.content.values()) {
                let span = this.$messagesContent.find(".chatMessage." + msg.role + ":last span");

                this._fillMsg(con, msg);

                span.html(this.chatgptToHtml(this.formLastText()));
            }
        } else {
            this.lastRole = msg.role;
            this.lastMsgId = msg.id;

            this.lastText = {};
            
            for(let con of msg.content.values()) {
                this._fillMsg(con, msg);
            }

            let spanBefore = null;
            let spanAfter = null;
            for (let i = msg.index; i>=0; i--) {
                spanBefore = this.$messagesContent.find(`.chatMessage[data-msgindex="${i}"]:last`);
                if(spanBefore.length > 0) {
                    break;
                }
            }
            if(!spanBefore || spanBefore.length == 0) {
                let lastIndex = this.$messagesContent.find(`.chatMessage:last`).data("msgindex");

                for (let i = msg.index; i<=lastIndex; i++) {
                    spanAfter = this.$messagesContent.find(`.chatMessage[data-msgindex="${i}"]:first`);

                    if(spanAfter.length > 0) {
                        break;
                    }
                }
            }

            let msgHtml = `<div class="chatMessage ${msg.role}" data-msgid="${msg.id}"  data-msgindex="${msg.index}"><span>${this.chatgptToHtml(this.formLastText())}</span><div class="styleDiv"><div></div></div></div>`;
            if(spanBefore && spanBefore.length > 0) {
                spanBefore.after(msgHtml)
            } else if(spanAfter && spanAfter.length > 0) {
                spanAfter.before(msgHtml)
            } else {
                this.$messagesContent.append(msgHtml);
            }

            this.updateScroll();
        }        
    },

    loadFileOrImage: function(file) {
        if (!file) {
            return false;
        }

        const maxSizeInBytes = 512 * 1024 * 1024;
        if (file.size > maxSizeInBytes) {
            app.notificationManager.addWarning("File size exceeds the 512 MB limit. " + file.type);
            return false; 
        }

        const supportedMimeTypes = [
            'image/', 'text/x-c', 'text/x-c++', 'text/x-csharp', 'text/css', 
            'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
            'text/x-golang', 'text/html', 'text/x-java', 'text/javascript', 
            'application/json', 'text/markdown', 'application/pdf', 'text/x-php', 
            'application/vnd.openxmlformats-officedocument.presentationml.presentation', 
            'text/x-python', 'text/x-script.python', 'text/x-ruby', 'application/x-sh', 
            'text/x-tex', 'application/typescript', 'text/plain'
        ];
        if (supportedMimeTypes.some(mime => file.type.startsWith(mime))) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.savedFileData = {name: file.name, file: reader.result};

                if (file.type.startsWith('image/')) {
                    this.$displayImage.attr('src', reader.result);
                    this.$fileData.hide();
                } else {
                    this.$fileData.show();
                }

                this.$hideImage.show();
                this.$loadImage.hide();
            };
            reader.readAsDataURL(file);
        } else {
            app.notificationManager.addWarning("Unsupported file type:" + file.type);
            return false; 
        }
        return true; 
    },

    updateScroll: function () {
        this.$messagesContent.perfectScrollbar('destroy');
        this.$messagesContent[0].scrollTop = this.$messagesContent[0].scrollTop + this.$aichat.find(`.messagesContent .chatMessage:last`)[0].getBoundingClientRect().top - 100;
        this.$messagesContent.perfectScrollbar({minScrollbarLength: 40});
    },

    scrollBottom: function () {
        this.$messagesContent.perfectScrollbar('destroy');        
        this.$messagesContent.animate({scrollTop: this.$messagesContent[0].scrollHeight - this.$messagesContent[0].clientHeight}, 1000);
        this.$messagesContent.perfectScrollbar({minScrollbarLength: 40});
    },

    formLastText: function() {
        let text = '';

        Object.keys(this.lastText)
            .sort(function(a, b) {return a - b;})
            .forEach(index => {text = text + this.lastText[index];});

        return text;
    },

    chatgptToHtml: function(text) {
        text = this.md && this.md.render(text);
        
        // remove Source
        text = text ? text.replace(/【(.*)】/gim, '') : '';

        return text;
    },




    initCodejigChatListener: async function () {
        let that = this;

        if(websocketClient.connectPromise) {
            await new Promise((resolve, reject) => {
                websocketClient.connectPromise.then(() => {
                    websocketClient.registerCodejigChatListener((msg)=>{that.codejigChatListener(msg)});
                    resolve();
                });
            })
        }
    },

    codejigChatListener: function (msg) {
        if(this.isOpened){
            if(msg.isFailed) {
                this.$waiter.hide();
                app.notificationManager.addError("Chat failed. Try again.");
                this.$tryAgain.show();
            } else {
                this.fillMsg(msg);
            }
        }
    },

    destroyListeners: function () {
        websocketClient.unregisterCodejigChatListener();
    },

    createChatAndLoadContext: async function () {
        await this.initCodejigChatListener();
        await utils.getRequest(app.urls.home + "codejig-gpt/createChatAndLoadContext");
    },

    tryAgain: async function () {
        await utils.getRequest(app.urls.home + "codejig-gpt/tryAgain");
    },

    clearChatContext: async function () {
        this.lastRole = null;
        this.lastMsgId = null;
        this.messagesLoaded = null;

        this.$messagesContent.empty();

        await utils.getRequest(app.urls.home + "codejig-gpt/clearChatContext");
        await utils.getRequest(app.urls.home + "codejig-gpt/createChatAndLoadContext");
    },

    _sendMessage: function (message) {
        utils.ajaxRequest({
          "message": message,
          "fileName": this.savedFileData.name || null,
          "file": this.savedFileData.file || null
        }, app.urls.home + "codejig-gpt/sendMessage",'post', ()=>{}, ()=>{}, true);
    }

})
export default CodejigChat;